import * as S from './styles'
import { statusBgKey } from 'commons/styles/StatusBG'

export enum StatusType {
  PENDENTE = 'PENDENTE',
  EM_APROVACAO = 'EM APROVAÇÃO',
  PROCESSANDO = 'PROCESSANDO',
  ENVIADO_AO_SAP = 'ENVIADO AO SAP',
  EM_RESERVA = 'EM RESERVA',
  EM_REMESSA = 'EM REMESSA',
  FATURAMENTO = 'FATURAMENTO',
  FATURADO = 'FATURADO',
  CONCLUIDO = 'CONCLUIDO',
  CANCELADO = 'CANCELADO',
  ABERTO = 'ABERTO',
  FECHADO = 'FECHADO',
  ANALISE = 'ANÁLISE',
  RESTRITO = 'RESTRITO'
}
export interface StatusProps {
  label: string
  status?: StatusType
}

export const Status: React.FC<StatusProps> = ({
  status = StatusType.PENDENTE,
  label
}) => {
  return <S.Container status={status as statusBgKey}>{label}</S.Container>
}
